module.exports = __webpack_public_path__ + "images/brooklyn-937d84b83f1bf762b97109afd65b30d6.jpg";